import { render, staticRenderFns } from "./WhatsAppInteractiveBuilder.vue?vue&type=template&id=5a87ddda&scoped=true&lang=pug&"
import script from "./WhatsAppInteractiveBuilder.vue?vue&type=script&lang=js&"
export * from "./WhatsAppInteractiveBuilder.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppInteractiveBuilder.vue?vue&type=style&index=0&id=5a87ddda&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87ddda",
  null
  
)

/* custom blocks */
import block0 from "./WhatsAppInteractiveBuilder.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports